import { canvasTranslationKeys } from './canvasTranslationKeys';
import { isMobile } from '../helpers/isMobile';
import { applicationStore } from '../../store/applicationStore';

const scale = 0.4;
const { isDemo } = applicationStore;

export const GameRulesKeys = [
  { key: canvasTranslationKeys.ABOUT_THE_GAME, type: 'title' },
  { key: canvasTranslationKeys.ABOUT_THE_GAME_P1, type: 'text' },
  { key: canvasTranslationKeys.GENERAL_INFORMATION, type: 'title' },
  { key: canvasTranslationKeys.QUICK_INFO_MATRIX_SIZE, type: 'text', isCircle: true },
  { key: canvasTranslationKeys.QUICK_INFO_PAY_LINE, type: 'text', isCircle: true },
  {
    key: canvasTranslationKeys.QUICK_INFO_RTP,
    type: 'text',
    isCircle: true,
    hasLicenseCheck: true,
  },
  { key: canvasTranslationKeys.RTP_GLI, type: 'text', isCircle: true, hasLicenseCheck: false },
  { key: canvasTranslationKeys.QUICK_INFO_VOLATILITY, type: 'text', isCircle: true },
  {
    key: canvasTranslationKeys.QUICK_INFO_MIN_BET,
    type: 'text',
    valueKey: 'minBet',
    isCircle: true,
    isCurrency: true,
    isLicense: true,
  },
  {
    key: canvasTranslationKeys.QUICK_INFO_MAX_BET,
    type: 'text',
    valueKey: 'maxBet',
    isCircle: true,
    isCurrency: true,
    isLicense: true,
  },
  {
    key: canvasTranslationKeys.QUICK_INFO_MAX_ODD,
    type: 'text',
    valueKey: 'maxOdd',
    isCircle: true,
    hasLicenseCheck: true,
  },
  { key: canvasTranslationKeys.GAME_INFO_HOW_TO_PLAY, type: 'title' },
  { key: canvasTranslationKeys.HOW_TO_PLAY_P1, type: 'text' },
  { key: canvasTranslationKeys.HOW_TO_PLAY_P2, type: 'text' },
  { key: canvasTranslationKeys.GAME_RULES_GAME_FEATURES, type: 'title' },
  { key: canvasTranslationKeys.WILD, type: 'title' },
  { key: canvasTranslationKeys.WILDS_TEXT, type: 'text' },
  { key: canvasTranslationKeys.WILD_RULES_P1, type: 'text' },
  { key: canvasTranslationKeys.AUTO_PLAY, type: 'title', hasAutoCheck: false },
  { key: canvasTranslationKeys.AUTO_SPIN_P1, type: 'text', hasAutoCheck: false },
  { key: canvasTranslationKeys.AUTO_SPIN_P2, type: 'text', hasAutoCheck: false },
  { key: canvasTranslationKeys.AUTO_SPIN_P3, type: 'text', hasAutoCheck: false },
  { key: canvasTranslationKeys.AUTO_SPIN_P4, type: 'text', hasAutoCheck: false },
  { key: canvasTranslationKeys.TURBO_MODE, type: 'title' },
  { key: canvasTranslationKeys.TURBO_MODE_P1, type: 'text' },
  { key: canvasTranslationKeys.CONNECTIVITY_AND_MALFUNCTION, type: 'title' },
  { key: canvasTranslationKeys.MALFUNCTION, type: 'text' },
  { key: canvasTranslationKeys.GAMBLE_FEATURE_TITLE, type: 'title', hasGambleCheck: false },
  { key: canvasTranslationKeys.GAMBLE_FEATURE_TEXT, type: 'text', hasGambleCheck: false },
  { key: canvasTranslationKeys.GAMBLE_VALIDATIONS, type: 'title', hasGambleCheck: false },
  {
    key: canvasTranslationKeys.GAMBLE_FEATURE_VALIDATIONS_TEXT,
    type: 'text',
    hasGambleCheck: false,
  },
];

export const JackPotRulesKeys = [
  { key: canvasTranslationKeys.JACKPOT, type: 'title' },
  { key: canvasTranslationKeys.JACKPOT_P1, type: 'text' },
  { key: canvasTranslationKeys.JACKPOT_P2, type: 'text' },
  { key: canvasTranslationKeys.JACKPOT_P3, type: 'text' },
  { key: canvasTranslationKeys.JACKPOT_P4, type: 'text' },
  { key: canvasTranslationKeys.JACKPOT_P5, type: 'text' },
  { key: canvasTranslationKeys.JACKPOT_P6, type: 'text' },
  { key: canvasTranslationKeys.JACKPOT_P7, type: 'title' },
  { key: canvasTranslationKeys.JACKPOT_P8, type: 'text' },
  { key: canvasTranslationKeys.JACKPOT_P9, type: 'text' },
  { key: canvasTranslationKeys.JACKPOT_P10, type: 'text' },
  { key: canvasTranslationKeys.JACKPOT_P11, type: 'text' },
  { key: canvasTranslationKeys.JACKPOT_P12, type: 'text' },
  { key: canvasTranslationKeys.JACKPOT_P13, type: 'title' },
  { key: canvasTranslationKeys.JACKPOT_P14, type: 'text' },
  { key: canvasTranslationKeys.JACKPOT_P15, type: 'text' },
  { key: canvasTranslationKeys.JACKPOT_P16, type: 'text' },
  { key: canvasTranslationKeys.JACKPOT_P17, type: 'text' },
  { key: canvasTranslationKeys.JACKPOT_P18, type: 'title' },
  { key: canvasTranslationKeys.JACKPOT_P19, type: 'text' },
  { key: canvasTranslationKeys.JACKPOT_P20, type: 'text' },
  { key: canvasTranslationKeys.JACKPOT_P21, type: 'title' },
  { key: canvasTranslationKeys.JACKPOT_P22, type: 'text' },
  { key: canvasTranslationKeys.JACKPOT_P23, type: 'text' },
  { key: canvasTranslationKeys.JACKPOT_P24, type: 'text' },
  { key: canvasTranslationKeys.JACKPOT_P25, type: 'text' },
];

export const HiddenGameRulesKeys = [
  { isHide: true, key: '', type: 'text' },
  { isHide: true, key: '', type: 'text' },
  { isHide: true, key: '', type: 'text' },
  { isHide: true, key: '', type: 'text' },
  { isHide: true, key: '', type: 'text' },
  { isHide: true, key: '', type: 'text' },
  { isHide: true, key: '', type: 'text' },
];

export const BoostedJackpotInfoPopupRulesKeys = [
  { key: canvasTranslationKeys.INTRO_DESCRIPTION_1, type: 'text' },
  { key: canvasTranslationKeys.INTRO_DESCRIPTION_2, type: 'text' },
  { key: canvasTranslationKeys.RULES_TITLE_1, type: 'title' },
  { key: canvasTranslationKeys.RULES_DESCRIPTION_2, type: 'text' },
  { key: canvasTranslationKeys.RULES_DESCRIPTION_3, type: 'text' },
  { key: canvasTranslationKeys.RULES_DESCRIPTION_4, type: 'text' },
  { key: canvasTranslationKeys.STATES_TITLE, type: 'title' },
  { key: canvasTranslationKeys.STATE_1, type: 'text' },
  { key: canvasTranslationKeys.STATE_2, type: 'text' },
  { key: canvasTranslationKeys.STATE_3, type: 'text' },
  { key: null, type: null, isSprite: true },
  { key: canvasTranslationKeys.VALIDATIONS_TITLE, type: 'title' },
  { key: canvasTranslationKeys.VALIDATIONS_1, type: 'text' },
  { key: canvasTranslationKeys.VALIDATIONS_2, type: 'text' },
];

export const licenseRulesKeys = [
  { key: null, type: null, textureName: ['spinButton'], isSprite: true, scale: 0 },
  { key: canvasTranslationKeys.GAME_CONTROLS, type: 'title', licenseRules: false },
  { key: null, type: null, textureName: ['spinButton'], isSprite: true, scale: scale },
  { key: canvasTranslationKeys.GAME_CONTROLS_P1, type: 'text', licenseRules: true },
  { key: null, type: null, textureName: ['spinStopButton'], isSprite: true, scale: scale },
  { key: canvasTranslationKeys.GAME_CONTROLS_P2, type: 'text', licenseRules: true },
  {
    key: null,
    type: null,
    textureName: ['quickBetButton'],
    isSprite: true,
    scale: scale,
    isSmallSprite: true,
  },
  { key: canvasTranslationKeys.GAME_CONTROLS_P3, type: 'text', licenseRules: true },
  { key: null, type: null, textureName: ['quickBetsListButton'], isSprite: true, scale: scale },
  { key: canvasTranslationKeys.GAME_CONTROLS_P4, type: 'text', licenseRules: true },
  {
    key: null,
    type: null,
    textureName: ['autoSpinButton'],
    isSprite: true,
    scale: scale,
    hasAutoCheck: false,
  },
  {
    key: canvasTranslationKeys.GAME_CONTROLS_P5,
    type: 'text',
    licenseRules: true,
    hasAutoCheck: false,
  },
  {
    key: null,
    type: null,
    textureName: ['speedStandard', 'speedFast', 'speedTurbo'],
    isSprite: true,
    scale: scale,
  },
  {
    key: canvasTranslationKeys.GAME_CONTROLS_P6,
    type: 'text',
    licenseRules: true,
    speedText: true,
  },
  { key: null, type: null, textureName: ['burgerIconLicense'], isSprite: true, scale: scale },
  {
    key: canvasTranslationKeys.GAME_CONTROLS_P7,
    type: 'text',
    licenseRules: true,
    isMobileCheck: true,
  },
  {
    key: null,
    type: null,
    textureName: ['fullScreenIconLicense'],
    isSprite: true,
    scale: scale,
    isMobileCheck: true,
  },
  { key: canvasTranslationKeys.GAME_CONTROLS_P8, type: 'text', licenseRules: true },
  {
    key: null,
    type: null,
    textureName: ['soundOnIconLIcense', 'soundOffIconLIcense'],
    isSprite: true,
    scale: scale,
  },
  {
    key: canvasTranslationKeys.GAME_CONTROLS_P9,
    type: 'text',
    licenseRules: true,
    soundsText: true,
  },
  { key: null, type: null, textureName: ['rulesIconLicense'], isSprite: true, scale: scale },
  { key: canvasTranslationKeys.GAME_CONTROLS_P10, type: 'text', licenseRules: true },
  {
    key: null,
    type: null,
    textureName: ['historyIconLicense'],
    isSprite: true,
    scale: scale,
    isDemoCheck: true,
  },
  { key: canvasTranslationKeys.GAME_CONTROLS_P12, type: 'text', licenseRules: true },

  { key: null, type: null, textureName: ['payTableIconLicense'], isSprite: true, scale: scale },
  {
    key: canvasTranslationKeys.GAME_CONTROLS_P11,
    type: 'text',
    licenseRules: true,
    isDemoCheck: true,
  },
  {
    key: null,
    type: null,
    textureName: ['spinButton'],
    isSprite: true,
    scale: 0,
  },
  {
    key: canvasTranslationKeys.GAMBLE_CONTROLS,
    type: 'title',
    licenseRules: false,
    hasGambleCheck: false,
  },
  {
    key: null,
    type: null,
    textureName: ['x2'],
    isSprite: true,
    hasGambleCheck: false,
    scale: scale,
  },
  {
    key: canvasTranslationKeys.GAMBLE_CONTROLS_P1,
    type: 'text',
    licenseRules: true,
    hasGambleCheck: false,
  },
  {
    key: null,
    type: null,
    textureName: ['spinCollectButton'],
    isSprite: true,
    scale: scale,
    hasGambleCheck: false,
  },
  {
    key: canvasTranslationKeys.GAMBLE_CONTROLS_P2,
    type: 'text',
    licenseRules: true,
    hasGambleCheck: false,
  },
  {
    key: null,
    type: null,
    textureName: ['jackpotButtonBlack'],
    isSprite: true,
    scale: scale,
    isSmallSprite: true,
    hasGambleCheck: false,
  },
  {
    key: canvasTranslationKeys.GAMBLE_CONTROLS_P3,
    type: 'text',
    licenseRules: true,
    hasGambleCheck: false,
  },
  {
    key: null,
    type: null,
    textureName: ['jackpotButtonRed'],
    isSprite: true,
    scale: scale,
    isSmallSprite: true,
    hasGambleCheck: false,
  },
  {
    key: canvasTranslationKeys.GAMBLE_CONTROLS_P4,
    type: 'text',
    licenseRules: true,
    hasGambleCheck: false,
  },
];
